<template>
<!-- eslint-disable max-len -->
<div class="playthrough-report">
  <div
    v-if="!playthrough"
    style="
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <blade-spinner
      nested
      noBackground
    />
  </div>
  <div v-else>
    <playthrough-metric-chart
      :playthrough="playthrough"
    />
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PlaythroughMetricChart from './components/PlaythroughMetricChart';
import BladeSpinner from '../../../components/BladeSpinner';

export default {
  props: {
    user: Object,
    workgroup: Object,
  },
  components: {
    PlaythroughMetricChart,
    BladeSpinner,
  },
  data() {
    return {
      playthrough: null,
      currentUser: null,
      currentWorkgroup: null,
    };
  },
  computed: {
    ...mapGetters([
    ]),
    userMatchesCurrentUser() {
      return (this.currentUser && this.user && `${this.currentUser._id}` === `${this.user._id}`)
        || (this.currentUser === this.user);
    },
    workgroupMatchesCurrentWorkgroup() {
      return (this.currentWorkgroup && this.workgroup && `${this.currentWorkgroup._id}` === `${this.workgroup._id}`)
        || (this.currentWorkgroup === this.workgroup);
    },
  },
  async created() {
    await this.fetchPlaythroughReportData();
  },
  methods: {
    ...mapActions([
      'getPlaythroughReport',
      'flashPrimary',
      'flashSuccess',
      'flashDanger',
    ]),
    async fetchPlaythroughReportData(force = false) {
      if (!(this.workgroup && this.user && this.workgroup._id && this.user._id)) return; // necessary parameters missing
      if (!force && this.userMatchesCurrentUser && this.workgroupMatchesCurrentWorkgroup) return; // already fetched

      try {
        this.playthrough = await this.getPlaythroughReport({
          classId: this.workgroup._id,
          userId: this.user._id,
        });

        this.currentUser = this.user;
        this.currentWorkgroup = this.workgroup;
      } catch (_) {
        const message = 'Error downloading data, please try again';
        this.flashDanger({ message });
      }
    },
  },
  watch: {
    async user() {
      await this.fetchPlaythroughReportData();
    },
    async workgroup() {
      await this.fetchPlaythroughReportData();
    },
  }
};
</script>

<style lang="scss" scoped>
.playthrough-report {
  background-color: white;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/PlaythroughReport.vue